module.exports = __webpack_public_path__ + "img/monnezza-right-bottom.a7cc0d98.png";